import { units_12 } from "../constants.js";
import { convertUnits } from "./convert.js";

//Codigos que se ven en los formularios
export const socialCodes = {
  days_worked: "Soc1",
  normal_hours_worked: "Soc2",
  fifty_percent_overtime: "Soc3",
  one_hundred_percent_overtime: "Soc4",
  female_production_workers: "Soc5",
  male_production_workers: "Soc6",
  other_gender_production_workers: "Soc7",
  female_administrative_workers: "Soc8",
  male_administrative_workers: "Soc9",
  administrative_workers_other_genders: "Soc10",
  female_temporary_workers: "Soc11",
  male_temporary_workers: "Soc12",
  temporary_workers_other_genders: "Soc13",
  female_workers_leadership_positions: "Soc14",
  male_workers_leadership_positions: "Soc15",
  workers_under_cct: "Soc16",
  work_accidents_with_sick_days: "Soc17",
  in_itine_accidents: "Soc18",
  first_aid_without_sick_days: "Soc19",
  hours_training_social_issues: "Soc20",
  hours_training_hys: "Soc21",
  hours_environmental_awareness_training: "Soc22",
  volunteer_hours: "Soc23",
  complaints_or_suggestions_received: "Soc24",
};

//Codigos de los indicadores que se ven en el dashboard
export const socialKPIsCodes = {
  quantity_workers_kpis: "KPIsoc1",
  quantity_permanent_workers_kpis: "KPIsoc2",
  quantity_temporary_workers_kpis: "KPIsoc3",
  quantity_workers_production_kpis: "KPIsoc4",
  quantity_workers_administrative_kpis: "KPIsoc5",
  total_days_worked_kpis: "KPIsoc6",
  total_hours_worked_kpis: "KPIsoc7",
  total_fifty_percent_overtime_kpis: "KPIsoc8",
  total_one_hundred_percent_overtime_kpis: "KPIsoc9",
  total_hours_worked_extra_and_normal_kpis: "KPIsoc10",
  average_female_workers_leadership_positions_kpis: "KPIsoc11",
  average_male_workers_leadership_positions_kpis: "KPIsoc12",
  average_female_total_kpis: "KPIsoc13",
  average_male_total_kpis: "KPIsoc14",
  quantity_workers_under_cct_kpis: "KPIsoc15",
  percentage_workers_under_cct_kpis: "KPIsoc16",
  // Numeración anterior (comentada)
  // total_work_accidents_with_sick_days_kpis: "KPIsoc15",
  // total_accidents_first_aid_kpis: "KPIsoc16",
  // total_in_itine_accidents_kpis: "KPIsoc17",
  // total_accidents_kpis: "KPIsoc18",
  // total_hours_training_social_issues_kpis: "KPIsoc19",
  // total_hours_training_hys_kpis: "KPIsoc20",
  // total_hours_environmental_awareness_training_kpis: "KPIsoc21",
  // total_volunteer_hours_kpis: "KPIsoc22",
  // total_complaints_or_suggestions_received_kpis: "KPIsoc23",
  // Nueva numeración (corregida según tabla)
  total_work_accidents_with_sick_days_kpis: "KPIsoc17",
  total_accidents_first_aid_kpis: "KPIsoc18",
  total_in_itine_accidents_kpis: "KPIsoc19",
  total_accidents_kpis: "KPIsoc20",
  total_hours_training_social_issues_kpis: "KPIsoc21",
  total_hours_training_hys_kpis: "KPIsoc22",
  total_hours_environmental_awareness_training_kpis: "KPIsoc23",
  total_volunteer_hours_kpis: "KPIsoc24",
  total_complaints_or_suggestions_received_kpis: "KPIsoc25",
};

//En base al valor del campo / key devuelve el valor correspondiente de acuerdo al año es de tipo {total, unit}
export function socialFormulasIndicators(field, year, data, baseline) {
  switch (field) {
    // KPIsoc1 = KPIsoc2 + KPIsoc3 + KPIsoc4 + KPIsoc5
    // Suma: Trabajadores permanentes + temporales + producción + administrativos
    // case "quantity_workers_kpis":
    //   let keys1 = [
    //     data["quantity_permanent_workers_kpis"]?.[year]?.total ||
    //       socialFormulasIndicators(
    //         "quantity_permanent_workers_kpis",
    //         year,
    //         data
    //       ).total, // KPIsoc2
    //     data["quantity_temporary_workers_kpis"]?.[year]?.total ||
    //       socialFormulasIndicators(
    //         "quantity_temporary_workers_kpis",
    //         year,
    //         data
    //       ).total, // KPIsoc3
    //     data["quantity_workers_production_kpis"]?.[year]?.total ||
    //       socialFormulasIndicators(
    //         "quantity_workers_production_kpis",
    //         year,
    //         data
    //       ).total, // KPIsoc4
    //     data["quantity_workers_administrative_kpis"]?.[year]?.total ||
    //       socialFormulasIndicators(
    //         "quantity_workers_administrative_kpis",
    //         year,
    //         data
    //       ).total, // KPIsoc5
    //   ];
    //   const sum = keys1.reduce(
    //     (acumulador, valorActual) => acumulador + valorActual,
    //     0
    //   );

    //   return {
    //     total: sum,
    //     unit: determineSocialUnits("quantity_workers_kpis")[0].value,
    //   };

    case "quantity_workers_kpis": {
  const workerKeys = [
    "female_production_workers",        // Soc5
    "male_production_workers",          // Soc6
    "other_gender_production_workers",  // Soc7
    "female_administrative_workers",    // Soc8
    "male_administrative_workers",      // Soc9
    "administrative_workers_other_genders", // Soc10
    "female_temporary_workers",         // Soc11
    "male_temporary_workers",           // Soc12
    "temporary_workers_other_genders",  // Soc13
    "female_workers_leadership_positions", // Soc14
    "male_workers_leadership_positions",   // Soc15
  ];

  let totalSum = 0;
  let monthCount = 0;
  let unit = "Un";

  workerKeys.forEach((key) => {
    const row = data[key]?.[year];
    if (!row) return;

    unit = row.unit || unit;
    totalSum += row.total || 0;
    if (row.count && row.count > monthCount) {
      monthCount = Math.min(row.count, 12); // máximo 12 meses
    }
  });

  return {
    total: monthCount > 0 ? totalSum / monthCount : 0,
    unit,
  };
}


    // KPIsoc2 = Soc (5 + 6 + 7 + 8 + 9 + 10 + 14 + 15) / meses del año completado
    // Trabajadores permanentes (producción + administrativos + liderazgo, excluyendo temporales)
    case "quantity_permanent_workers_kpis": {
  const permanentKeys = [
    "female_production_workers",               // Soc5
    "male_production_workers",                 // Soc6
    "other_gender_production_workers",         // Soc7
    "female_administrative_workers",           // Soc8
    "male_administrative_workers",             // Soc9
    "administrative_workers_other_genders",    // Soc10
    "female_workers_leadership_positions",     // Soc14
    "male_workers_leadership_positions",       // Soc15
  ];

  let total = 0;
  let unit = "Un";

  permanentKeys.forEach((key) => {
    const row = data[key]?.[year];
    if (!row?.count) return;
    unit = row.unit || unit;
    total += row.total / row.count; // promedio mensual
  });

  return {
    total,
    unit,
  };
}

    // KPIsoc3 = Soc11 + Soc12 + Soc13
    // Trabajadores temporales (femeninas + masculinos + otro género)
    case "quantity_temporary_workers_kpis": {
  const keys = [
    "female_temporary_workers",
    "male_temporary_workers",
    "temporary_workers_other_genders",
  ];

  let total = 0;
  let unit = "Un";

  keys.forEach((key) => {
    const row = data[key]?.[year];
    console.log(`KPIsoc3 - ${key} [${year}]:`, row ? { total: row.total, count: row.count, unit: row.unit } : "SIN DATOS");
    if (!row?.count) return;
    unit = row.unit || unit;
    total += row.total / row.count;
  });

  console.log(`KPIsoc3 - Total temporales [${year}]:`, total);

  return {
    total,
    unit,
  };
}

    // KPIsoc4 = Suma Soc (5 + 6 + 7 + 11 + 12 + 13) / meses del año completado
    // Trabajadores en producción (permanentes + temporales)
    case "quantity_workers_production_kpis": {
  const keys = [
    "female_production_workers",           // Soc5
    "male_production_workers",             // Soc6
    "other_gender_production_workers",     // Soc7
    "female_temporary_workers",            // Soc11
    "male_temporary_workers",              // Soc12
    "temporary_workers_other_genders",     // Soc13
  ];

  let total = 0;
  let unit = "Un";

  keys.forEach((key) => {
    const row = data[key]?.[year];
    if (!row?.count) return;
    unit = row.unit || unit;
    total += row.total / row.count; // promedio mensual
  });

  return {
    total,
    unit,
  };
}

    // KPIsoc5 = Soc8 + Soc9 + Soc10 + Soc14 + Soc15
    // Trabajadores administrativos (femeninas + masculinos + otro género + liderazgo fem + liderazgo masc)
    case "quantity_workers_administrative_kpis": {
  const keys = [
    "female_administrative_workers",
    "male_administrative_workers",
    "administrative_workers_other_genders",
    "female_workers_leadership_positions",
    "male_workers_leadership_positions",
  ];

  let total = 0;
  let unit = "Un";

  keys.forEach((key) => {
    const row = data[key]?.[year];
    if (!row?.count) return;
    unit = row.unit || unit;
    total += row.total / row.count;
  });

  return {
    total,
    unit,
  };
}

    // KPIsoc6 = Soc1
    // Total de días trabajados (suma de celda total)
    case "total_days_worked_kpis":
      return {
        total: data["days_worked"]?.[year]?.total,  // Soc1
        unit: data["days_worked"]?.[year].unit,
      };
    // KPIsoc7 = Soc2
    // Total de horas trabajadas normales (suma de celda total)
    case "total_hours_worked_kpis":
      return {
        total: data["normal_hours_worked"]?.[year]?.total,  // Soc2
        unit: data["normal_hours_worked"]?.[year].unit,
      };
    // KPIsoc8 = Soc3
    // Total de horas extras al 50% (suma de celda total)
    case "total_fifty_percent_overtime_kpis":
      return {
        total: data["fifty_percent_overtime"]?.[year]?.total,  // Soc3
        unit: data["fifty_percent_overtime"]?.[year].unit,
      };
    // KPIsoc9 = Soc4
    // Total de horas extras al 100% (suma de celda total)
    case "total_one_hundred_percent_overtime_kpis":
      return {
        total: data["one_hundred_percent_overtime"]?.[year]?.total,  // Soc4
        unit: data["one_hundred_percent_overtime"]?.[year].unit,
      };
    // KPIsoc10 = KPIsoc7 + KPIsoc8 + KPIsoc9
    // Suma de celda total: Horas normales + horas extras 50% + horas extras 100%
    // KPIsoc10 = Soc2 + Soc3 + Soc4
    case "total_hours_worked_extra_and_normal_kpis":
      let keys6 = [
        data["total_hours_worked_kpis"]?.[year]?.total ||
          socialFormulasIndicators("total_hours_worked_kpis", year, data).total,  // KPIsoc7 = Soc2
        data["total_fifty_percent_overtime_kpis"]?.[year]?.total ||
          socialFormulasIndicators(
            "total_fifty_percent_overtime_kpis",
            year,
            data
          ).total,  // KPIsoc8 = Soc3
        data["total_one_hundred_percent_overtime_kpis"]?.[year]?.total ||
          socialFormulasIndicators(
            "total_one_hundred_percent_overtime_kpis",
            year,
            data
          ).total,  // KPIsoc9 = Soc4
      ];
      const sum1 = keys6.reduce(
        (acumulador, valorActual) => acumulador + valorActual,
        0
      );

      return {
        total: sum1,
        unit:
          data["total_hours_worked_kpis"]?.[year].unit ||
          determineSocialUnits("total_hours_worked_kpis")[0].value,
      };
    // KPIsoc11 = Soc14 / (Soc14 + Soc15)
    // Promedio de trabajadoras femeninas en posiciones de liderazgo (celda promedio)
    case "average_female_workers_leadership_positions_kpis":
      let result =
        data["female_workers_leadership_positions"]?.[year].average /  // Soc14
        (data["female_workers_leadership_positions"]?.[year].average +  // Soc14
          data["male_workers_leadership_positions"]?.[year].average);   // Soc15
      return {
        total: result,
        unit:
          data["female_workers_leadership_positions"]?.[year].unit ||
          determineSocialUnits("female_workers_leadership_positions")[0].value,
          unit: "%",
      };
    // KPIsoc12 = Soc15 / (Soc14 + Soc15)
    // Promedio de trabajadores masculinos en posiciones de liderazgo (celda promedio)
    case "average_male_workers_leadership_positions_kpis":
      let result1 =
        data["male_workers_leadership_positions"]?.[year].average /  // Soc15
        (data["female_workers_leadership_positions"]?.[year].average +  // Soc14
          data["male_workers_leadership_positions"]?.[year].average);   // Soc15
      return {
        total: result1,
        unit:
          data["male_workers_leadership_positions"]?.[year].unit ||
          determineSocialUnits("male_workers_leadership_positions")[0].value,
          unit: "%",
      };
    // KPIsoc13 = Suma Soc (5 + 8 + 11 + 14) / KPIsoc1
    // Promedio total de trabajadoras femeninas sobre cantidad total de trabajadores (celda promedio)
    case "average_female_total_kpis":
      let keys9 = [
        "female_production_workers",              // Soc5
        "female_administrative_workers",          // Soc8
        "female_temporary_workers",               // Soc11
        "female_workers_leadership_positions",    // Soc14
      ];

      let unit4 =
        data["female_production_workers"]?.[year].unit ||
        determineSocialUnits("female_production_workers")[0].value;
      return {
        total:
          addDataAverage(keys9, year, data, unit4) /  // (Soc5 + Soc8 + Soc11 + Soc14)
            data["quantity_workers_kpis"]?.[year].total || 1,  // KPIsoc1
        unit: "%",
      };
    // KPIsoc14 = Suma Soc (6 + 9 + 12 + 15) / KPIsoc1
    // Promedio total de trabajadores masculinos sobre cantidad total de trabajadores (celda promedio)
    case "average_male_total_kpis":
      let keys10 = [
        "male_production_workers",             // Soc6
        "male_administrative_workers",         // Soc9
        "male_temporary_workers",              // Soc12
        "male_workers_leadership_positions",   // Soc15
      ];

      let unit5 =
        data["male_production_workers"]?.[year].unit ||
        determineSocialUnits("male_production_workers")[0].value;
      return {
        total:
          addDataAverage(keys10, year, data, unit5) /  // (Soc6 + Soc9 + Soc12 + Soc15)
            data["quantity_workers_kpis"]?.[year].total || 1,  // KPIsoc1
        unit: "%",
      };
    // KPIsoc15 = Soc16
    // Cantidad de trabajadores bajo CCT (suma de celda total)
    case "quantity_workers_under_cct_kpis":
      return {
        total: data["workers_under_cct"]?.[year]?.total,
        unit: data["workers_under_cct"]?.[year]?.unit || "Unid.",
      };
    // KPIsoc16 = Soc16 / KPIsoc1
    // Porcentaje de trabajadores bajo CCT sobre total de trabajadores
    case "percentage_workers_under_cct_kpis":
      const totalCCT = data["workers_under_cct"]?.[year]?.total || 0;
      const totalWorkers = data["quantity_workers_kpis"]?.[year]?.total || 1;
      return {
        total: totalCCT / totalWorkers,
        unit: "%",
      };
    // KPIsoc17 = Soc17
    // Total de accidentes laborales con días de baja (suma de celda total)
    case "total_work_accidents_with_sick_days_kpis":
      return {
        total: data["work_accidents_with_sick_days"]?.[year]?.total,  // Soc17
        unit: data["work_accidents_with_sick_days"]?.[year].unit,
      };
    // KPIsoc18 = Soc19
    // Total de primeros auxilios sin días de baja (suma de celda total)
    case "total_accidents_first_aid_kpis":
      return {
        total: data["first_aid_without_sick_days"]?.[year]?.total,  // Soc19
        unit: data["first_aid_without_sick_days"]?.[year].unit,
      };
    // KPIsoc19 = Soc18
    // Total de accidentes in itinere (suma de celda total)
    case "total_in_itine_accidents_kpis":
      return {
        total: data["in_itine_accidents"]?.[year]?.total,  // Soc18
        unit: data["in_itine_accidents"]?.[year].unit,
      };
    // KPIsoc20 = KPIsoc17 + KPIsoc18 + KPIsoc19
    // Total de accidentes (suma de celda total)
    case "total_accidents_kpis":
      let key7 = [
        data["total_work_accidents_with_sick_days_kpis"]?.[year]?.total ||
          socialFormulasIndicators(
            "total_work_accidents_with_sick_days_kpis",
            year,
            data
          ).total,  // KPIsoc17
        data["total_accidents_first_aid_kpis"]?.[year]?.total ||
          socialFormulasIndicators("total_accidents_first_aid_kpis", year, data)
            .total,  // KPIsoc18
        data["total_in_itine_accidents_kpis"]?.[year]?.total ||
          socialFormulasIndicators("total_in_itine_accidents_kpis", year, data)
            .total,  // KPIsoc19
      ];
      const sum2 = key7.reduce(
        (acumulador, valorActual) => acumulador + valorActual,
        0
      );

      return {
        total: sum2,
        unit:
          data["total_work_accidents_with_sick_days_kpis"]?.[year].unit ||
          determineSocialUnits("total_work_accidents_with_sick_days_kpis")[0]
            .value,
      };
    // KPIsoc21 = Soc20
    // Total de horas de capacitación en temas sociales (suma de celda total)
    case "total_hours_training_social_issues_kpis":
      return {
        total: data["hours_training_social_issues"]?.[year]?.total,  // Soc20
        unit: data["hours_training_social_issues"]?.[year].unit,
      };
    // KPIsoc22 = Soc21
    // Total de horas de capacitación en higiene y seguridad (suma de celda total)
    case "total_hours_training_hys_kpis":
      return {
        total: data["hours_training_hys"]?.[year]?.total,  // Soc21
        unit: data["hours_training_hys"]?.[year].unit,
      };
    // KPIsoc23 = Soc22
    // Total de horas de capacitación en concientización ambiental (suma de celda total)
    case "total_hours_environmental_awareness_training_kpis":
      return {
        total: data["hours_environmental_awareness_training"]?.[year]?.total,  // Soc22
        unit: data["hours_environmental_awareness_training"]?.[year].unit,
      };
    // KPIsoc24 = Soc23
    // Total de horas de voluntariado (suma de celda total)
    case "total_volunteer_hours_kpis":
      return {
        total: data["volunteer_hours"]?.[year]?.total,  // Soc23
        unit: data["volunteer_hours"]?.[year].unit,
      };
    // KPIsoc25 = Soc24
    // Total de quejas o sugerencias recibidas (suma de celda total)
    case "total_complaints_or_suggestions_received_kpis":
      return {
        total: data["complaints_or_suggestions_received"]?.[year]?.total,  // Soc24
        unit: data["complaints_or_suggestions_received"]?.[year].unit,
      };
    default:
      return false;
  }
}

//Suma los valores de los campos/claves pasadas como parametros
function addData(keys, year, data, unitSelected) {
  let suma = 0;
  //tomo como referencia el kwh
  for (let clave of keys) {
    if (data.hasOwnProperty(clave)) {
      suma +=
        convertUnits(
          data[clave]?.[year]?.total,
          data[clave]?.[year].unit,
          unitSelected
        ) || 0;
    }
  }

  return suma;
}

//Suma los valores de los campos/claves pasadas como parametros
function addDataAverage(keys, year, data, unitSelected) {
  let suma = 0;

  //tomo como referencia el kwh
  for (let clave of keys) {
    if (data.hasOwnProperty(clave)) {
      suma +=
        convertUnits(
          data[clave]?.[year].average,
          data[clave]?.[year].unit,
          unitSelected
        ) || 0;
    }
  }

  return suma;
}

//Determina las unidades utilizadas de acuerdo a cada campo/key ver boceto con unidades
export const determineSocialUnits = (value) => {
  // Todos los campos usan "Unid." como unidad
  return [
    { key: 1, value: "Unid.", name: "Unid." },
  ];
};
